import React, { } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import GrowOnScroll from '../UI/GrowOnScroll/GrowOnScroll';
import AdminMenu from './AdminMenu/AdminMenu';
import AdminLoads from './Loads/AdminLoads';
import Users from './Users/Users';
import Prices from './Prices/Prices';
import Settings from './Settings/Settings';
import { useAppSelector } from '../../store/hooks';


const Admin: React.FC = () => {
  const user = useAppSelector(state => state.auth.user);

  return (
    <div>
      {user?.userType === 'admin' && (
        <GrowOnScroll>
          <AdminMenu />
        </GrowOnScroll>
      )}

      <Routes>
        <Route
          path='/loads'
          element={<AdminLoads />}
        />

        <Route
          path='/users'
          element={<Users />}
        />

        <Route
          path='/prices'
          element={<Prices />}
        />

        {user?.userType === 'owner' && (
          <Route
            path='/settings'
            element={<Settings />}
          />
        )}

        <Route
          path='/'
          element={<Navigate to="loads" />}
        />
      </Routes>
    </div>
  );
};

export default Admin;
